export default function Cash(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={17.497} height={15} {...props}>
      <defs>
        <linearGradient id="a" y1={0.5} x2={1} y2={0.5} gradientUnits="objectBoundingBox">
          <stop offset={0} stopColor="#247829" />
          <stop offset={1} stopColor="#2c8a30" />
        </linearGradient>
        <linearGradient id="b" y1={0.5} x2={1} y2={0.5} gradientUnits="objectBoundingBox">
          <stop offset={0} stopColor="#277a2d" />
          <stop offset={1} stopColor="#216e27" />
        </linearGradient>
        <linearGradient id="c" y1={0.5} x2={1} y2={0.5} gradientUnits="objectBoundingBox">
          <stop offset={0} stopColor="#4bab4c" />
          <stop offset={1} stopColor="#2c8a2f" />
        </linearGradient>
        <linearGradient id="e" y1={0.5} x2={1} y2={0.5} gradientUnits="objectBoundingBox">
          <stop offset={0} stopColor="#74d461" />
          <stop offset={1} stopColor="#64ba56" />
        </linearGradient>
        <linearGradient
          id="f"
          x1={-1.842}
          y1={-0.253}
          x2={1.484}
          y2={0.814}
          gradientUnits="objectBoundingBox">
          <stop offset={0} stopColor="#00a9f7" />
          <stop offset={1} stopColor="#0048a6" />
        </linearGradient>
        <linearGradient id="g" y1={0.5} x2={1} y2={0.5} gradientUnits="objectBoundingBox">
          <stop offset={0} stopColor="#157519" />
          <stop offset={1} stopColor="#154522" />
        </linearGradient>
        <linearGradient id="h" y1={0.5} x2={1} y2={0.5} gradientUnits="objectBoundingBox">
          <stop offset={0} stopColor="#25752c" />
          <stop offset={1} stopColor="#1c5c25" />
        </linearGradient>
        <linearGradient id="i" y1={0.5} x2={1} y2={0.5} gradientUnits="objectBoundingBox">
          <stop offset={0} stopColor="#2c8a30" />
          <stop offset={1} stopColor="#247829" />
        </linearGradient>
        <linearGradient id="j" y1={0.5} x2={1} y2={0.5} gradientUnits="objectBoundingBox">
          <stop offset={0} stopColor="#2c8a30" />
          <stop offset={1} stopColor="#227028" />
        </linearGradient>
        <linearGradient id="k" y1={0.5} x2={1} y2={0.5} gradientUnits="objectBoundingBox">
          <stop offset={0} stopColor="#309631" />
          <stop offset={1} stopColor="#51b850" />
        </linearGradient>
        <linearGradient id="l" y1={0.5} x2={1} y2={0.5} gradientUnits="objectBoundingBox">
          <stop offset={0} stopColor="#74d461" />
          <stop offset={1} stopColor="#95eb88" />
        </linearGradient>
        <linearGradient
          id="m"
          x1={-0.789}
          y1={-1.201}
          x2={0.836}
          y2={0.933}
          gradientUnits="objectBoundingBox">
          <stop offset={0} stopColor="#d5dceb" />
          <stop offset={0.379} stopColor="#c5cde1" />
          <stop offset={1} stopColor="#a5afcc" />
        </linearGradient>
        <linearGradient
          id="n"
          x1={0.037}
          y1={-0.342}
          x2={1.228}
          y2={1.799}
          gradientUnits="objectBoundingBox">
          <stop offset={0} stopColor="#e99938" />
          <stop offset={1} stopColor="#e6332a" />
        </linearGradient>
        <linearGradient id="o" y1={0.5} x2={1} y2={0.5} gradientUnits="objectBoundingBox">
          <stop offset={0} stopColor="#f8faff" />
          <stop offset={0.416} stopColor="#e8effc" />
          <stop offset={1} stopColor="#cddbf7" />
        </linearGradient>
        <linearGradient id="p" y1={0.5} x2={0.653} y2={0.5} gradientUnits="objectBoundingBox">
          <stop offset={0} stopColor="#ffb217" />
          <stop offset={1} stopColor="#e99938" />
        </linearGradient>
        <linearGradient id="q" y1={0.5} x2={1} y2={0.5} gradientUnits="objectBoundingBox">
          <stop offset={0} stopColor="#154522" />
          <stop offset={1} stopColor="#0e5219" />
        </linearGradient>
        <radialGradient
          id="d"
          cx={0.645}
          cy={-0.897}
          r={2.412}
          gradientTransform="matrix(.695 0 0 1 .152 0)"
          gradientUnits="objectBoundingBox">
          <stop offset={0} stopColor="#00562f" />
          <stop offset={1} stopColor="#fff" />
        </radialGradient>
      </defs>
      <g data-name="Component 10 \u2013 9" fillRule="evenodd">
        <path
          data-name="Path 159"
          d="m14.924 6.882 2.5 1.7-5.786 2.984 3.285-4.689Z"
          fill="#00562f"
        />
        <path
          data-name="Path 160"
          d="m14.944 6.178 2.5 1.7-5.786 2.984 3.285-4.689Z"
          fill="#00562f"
        />
        <path
          data-name="Path 161"
          d="m14.973 5.165 2.5 1.7-5.786 2.984 3.285-4.689Z"
          fill="#00562f"
        />
        <path
          data-name="Path 162"
          d="m.965 8.51.071 2.758L5.925 15l11.494-6.169.007-.245-2.87 1.433 2.875-1.611.015-.527-2.039.991 2.044-1.191.023-.812-3.969 1.956 3.975-2.166.017-.6-5-3.411L.966 8.504Z"
          fill="#427f4b"
        />
        <path
          data-name="Path 163"
          d="m-122.308 313.622 4.966 3.521-.005 2.968-4.889-3.732-.071-2.757Z"
          transform="translate(123.273 -305.112)"
          fill="url(#a)"
        />
        <path
          data-name="Path 164"
          d="m-94.59 307.6 11.566-5.966-.017.6-3.975 2.165 3.969-1.956-.023.812-2.044 1.191 2.039-.991-.015.527-2.875 1.611 2.87-1.433-.007.245-11.498 6.163.005-2.968Z"
          transform="translate(100.521 -295.568)"
          fill="url(#b)"
        />
        <path
          data-name="Path 165"
          d="m-122.308 290.759 5.763-2.927 5.767-2.929 2.5 1.707 2.5 1.7-5.786 2.984-5.781 2.982q-1.242-.879-2.483-1.76l-2.482-1.761Z"
          transform="translate(123.273 -282.249)"
          fill="url(#c)"
        />
        <path
          data-name="Path 166"
          d="m-72.826 305.592 1.424 2.12 6.173-3.313.007-.245-2.87 1.433 2.875-1.611.015-.527-2.039.991 2.044-1.191.023-.812-3.969 1.956 3.975-2.165.017-.6-7.675 3.959Z"
          transform="translate(82.648 -295.568)"
          opacity={0.45}
          fill="url(#d)"
          style={{
            mixBlendMode: 'multiply',
            isolation: 'isolate'
          }}
        />
        <path
          data-name="Path 167"
          d="m-113.912 293.875 4.574-2.326 4.575-2.326a1.481 1.481 0 0 0 1.364.061l1.468 1 1.466 1c-.4.207-.448.571-.1.81q-2.294 1.183-4.588 2.363l-4.586 2.362a1.45 1.45 0 0 0-1.364-.067l-1.457-1.031-1.456-1.031c.4-.206.448-.573.1-.818Zm2.911-.9a3.211 3.211 0 0 1 1.67-.281 3.375 3.375 0 0 1 1.635.54 1.271 1.271 0 0 1 .643 1.049 1.168 1.168 0 0 1-.729.946 3.179 3.179 0 0 1-1.671.287 3.352 3.352 0 0 1-1.633-.547 1.277 1.277 0 0 1-.64-1.053 1.158 1.158 0 0 1 .726-.942Zm3.717-.766 1.835-.938 1.837-.938a.215.215 0 0 1 .2.009l.326.223c.051.035.043.089-.015.118q-.92.472-1.838.94t-1.835.94a.211.211 0 0 1-.2-.01l-.324-.225c-.051-.036-.046-.088.013-.118Zm.974.716 2.493-1.278a.149.149 0 0 1 .137.007c.073.051.148.1.221.152.034.023.028.06-.011.081l-2.495 1.279a.145.145 0 0 1-.134-.006c-.074-.051-.147-.1-.221-.154-.033-.024-.031-.06.01-.081Z"
          transform="translate(116.463 -285.687)"
          fill="url(#e)"
        />
        <path
          data-name="Path 168"
          d="m3.848 10.912 2.082 1.4 8.163-4.139L5.93 12.49l-2.082-1.578Z"
          fill="#1f3f37"
          opacity={0.5}
        />
        <path
          data-name="Path 169"
          d="m2.453 10.262 3.476 2.419 1.834-.863-1.834 1.037-3.476-2.593Z"
          fill="#1f3f37"
          opacity={0.5}
        />
        <path
          data-name="Path 170"
          d="m4.888 12.754 1.04.685 4.19-2.124-4.191 2.291-1.04-.851Z"
          fill="#1f3f37"
          opacity={0.5}
        />
        <path
          data-name="Path 171"
          d="m3.632 12.893 2.295 1.662 2.914-1.482-2.914 1.629-2.295-1.809Z"
          fill="#1f3f37"
          opacity={0.5}
        />
        <path
          data-name="Path 172"
          d="m5.894 6.007 4.9 3.515 1.958-1.01-4.965-3.467-1.894.962Z"
          fill="#e6e6ff"
        />
        <path
          data-name="Path 173"
          d="m11.285 9.27-4.917-3.5-.473.24 4.9 3.515.489-.252ZM7.314 5.286l4.949 3.479.49-.252-4.965-3.467-.473.24Z"
          fill="#ff994c"
        />
        <path
          data-name="Path 174"
          d="m10.795 9.523.02 2.853.477-.256q0-1.425-.008-2.849l-.489.252Zm1.468-.757-.016 2.842.477-.256.028-2.838-.49.252Z"
          fill="#cc664c"
        />
        <g data-name="Group 2695">
          <path
            data-name="Path 175"
            d="m10.795 9.521.02 2.853 1.909-1.025.028-2.838-1.958 1.01Z"
            fill="#b3b3b3"
          />
          <path
            data-name="Path 176"
            d="m-67.389 314.644.014 1.971.006.882.477-.256q0-1.425-.008-2.849l-.489.252Zm1.468-.757-.016 2.842.477-.256.028-2.838-.49.252Z"
            transform="translate(78.184 -305.122)"
            fill="url(#f)"
          />
        </g>
        <path
          data-name="Path 177"
          d="m-121.732 308.327-5.723-1.126v-.135l.609-.484 5.116 1.745Z"
          transform="translate(127.5 -299.507)"
          fill="url(#g)"
        />
        <path
          data-name="Path 178"
          d="m-121.778 304.884-5.72-.847v-.414l.609-.484 5.116 1.745Z"
          transform="translate(127.538 -296.766)"
          fill="url(#g)"
        />
        <path
          data-name="Path 179"
          d="m-122.581 299.57-4.986-.646v-.414l.609-.484 4.382 1.544Z"
          transform="translate(127.594 -292.696)"
          fill="url(#g)"
        />
        <path
          data-name="Path 180"
          d="m-110.519 290.427-.041 2.808-2.482 4.471-14.553-3.268v-.27l2.34.45-2.343-.633-.006-.519 5.482 1.2-5.484-1.415-.01-.827 3.934.863-3.937-1.137-.007-.582 1.1-.874 15.719-.313.29.047Z"
          transform="translate(127.641 -286.609)"
          fill="url(#h)"
        />
        <path
          data-name="Path 181"
          d="m-43.617 290.609-2.506 4.436-.017 2.843 2.482-4.471.041-2.808Z"
          transform="translate(60.739 -286.791)"
          fill="url(#b)"
        />
        <path
          data-name="Path 182"
          d="M-113.024 299.5a145.074 145.074 0 0 1-14.6-3.3l.007.582 3.937 1.137-3.934-.863.01.827 5.484 1.415-5.482-1.2.006.519 2.343.633-2.34-.45v.27l14.553 3.268.017-2.843Z"
          transform="translate(127.64 -291.246)"
          fill="url(#i)"
        />
        <path
          data-name="Path 183"
          d="m-110.582 288.792-2.513 4.459a68.43 68.43 0 0 1-14.6-3.26l1.209-1.083 15.565-.178.341.062Z"
          transform="translate(127.697 -285.295)"
          fill="url(#j)"
        />
        <path
          data-name="Path 184"
          d="m-110.524 274.948-2.56 4.5A38.326 38.326 0 0 1-127.6 276.2l2.886-4.316a34.559 34.559 0 0 0 14.193 3.063Z"
          transform="translate(127.62 -271.885)"
          fill="url(#k)"
        />
        <path
          data-name="Path 185"
          d="m15.756 6.582-1.142 1.9a123.884 123.884 0 0 1-5.6-.962c1.847.448 3.71.854 5.6 1.179l1.143-2.12Z"
          fill="#1f3f37"
          opacity={0.5}
        />
        <path
          data-name="Path 186"
          d="m15.162 8.336-.552.893c-1.124-.167-2.243-.368-3.362-.566 1.12.261 2.241.523 3.361.752l.553-1.078Z"
          fill="#1f3f37"
          opacity={0.5}
        />
        <path
          data-name="Path 187"
          d="m16.123 7.661-1.519 2.61-5.886-1.157 5.885 1.362 1.52-2.815Z"
          fill="#1f3f37"
          opacity={0.5}
        />
        <path
          data-name="Path 188"
          d="M-118.537 276.363a45.04 45.04 0 0 0 5.382 1.655 41.259 41.259 0 0 0 5.889.835c-.179.313.119.585.676.592-.249.44-.5.879-.755 1.318s-.5.879-.755 1.318a1.632 1.632 0 0 0-1.343.532 42.106 42.106 0 0 1-5.969-.943 56.336 56.336 0 0 1-5.491-1.711c.2-.3-.021-.688-.48-.869.278-.42.56-.839.839-1.259s.557-.841.837-1.26a1 1 0 0 0 1.17-.207Zm2.533 1.386a2.025 2.025 0 0 1 1.177.813 1.054 1.054 0 0 1-.014 1.147 2.1 2.1 0 0 1-1.223.831 3.057 3.057 0 0 1-1.706-.014 1.915 1.915 0 0 1-1.163-.869 1.129 1.129 0 0 1 .06-1.18 1.981 1.981 0 0 1 1.206-.776 3.185 3.185 0 0 1 1.664.048Zm2.874 1.682c.769.157 1.545.307 2.335.421s1.6.193 2.425.257c.08.006.125.044.1.09l-.169.291a.223.223 0 0 1-.193.076c-.823-.065-1.634-.147-2.43-.263s-1.568-.266-2.336-.425c-.074-.015-.112-.066-.085-.11.058-.1.117-.189.176-.284a.184.184 0 0 1 .181-.054Zm-.581.874q1.57.322 3.2.549c.053.007.083.037.065.068-.038.066-.079.13-.118.2a.138.138 0 0 1-.128.044q-1.627-.229-3.2-.555c-.05-.01-.077-.044-.058-.075.039-.063.081-.127.12-.192a.123.123 0 0 1 .125-.036Z"
          transform="translate(122.512 -275.45)"
          fill="url(#l)"
        />
        <g data-name="Group 2696">
          <path
            data-name="Path 189"
            d="m-91.467 304.105.039 2.712-2.242-.5-.037-2.729 2.337.521Z"
            transform="translate(99.791 -297.121)"
            fill="url(#m)"
          />
          <path
            data-name="Path 190"
            d="m-92.291 303.911.6.134.015 2.729-.594-.134-.023-2.729Zm-1.2-.268.037 2.73-.594-.134-.045-2.731.6.134Z"
            transform="translate(100.111 -297.061)"
            fill="url(#n)"
          />
          <path
            data-name="Path 191"
            d="m-88.829 282.357-2.675 4.449-2.3-.512 2.7-4.424c.771.193 1.491.348 2.273.487Z"
            transform="translate(99.87 -279.834)"
            fill="url(#o)"
          />
          <path
            data-name="Path 192"
            d="m-90.787 281.989-2.707 4.412-.6-.134 2.735-4.416q.286.072.574.138Zm-1.5 4.68 2.668-4.431q.295.058.591.11l-2.658 4.455-.6-.134Z"
            transform="translate(100.111 -279.819)"
            fill="url(#p)"
          />
        </g>
        <path
          data-name="Path 193"
          d="m-118.686 312 8.209 1.844s-1.6-.2-3.35-.615c-3.062-.729-4.859-1.229-4.859-1.229Z"
          transform="translate(120.299 -303.825)"
          opacity={0.4}
          fill="url(#q)"
        />
      </g>
    </svg>
  );
}
